'use strict';
const angular = require('angular');

/**
 * Signature component.
 * This module will initialize the Signature component for angular application.
 * @module Signature
 */

export class SignatureComponent {
    signature:any;
    signatureItem:any;
    signatureColor:any;
    signatureDisabled: any;
    signatureChanged: any;
    signatureVal: any;
    ignoreValChangeEvent: boolean = false;
    initialized: Boolean = false;
    $translate: any;

    constructor($element,$translate) {
        this.$translate=$translate;
        this.signature = $element.find('div');
    }

    $onInit(){
        if(!this.signatureItem) {
            return;
        }

        this.draw()
        this.initialized = true;
        var resetBtn = this.signature.find('.reset');
         resetBtn[0].innerHTML = this.$translate.instant('reset');
         var undoBtn = this.signature.find('.undo');
         undoBtn[0].innerHTML = this.$translate.instant('undo');
    }

    $onChanges(changedProps){
        if(!this.initialized || !changedProps) {
            return;
        }
        if(changedProps.signatureDisabled != undefined) {
            if(this.signatureDisabled) {
                this.signature.jSignature('disable', true);
                this.signature.find('.reset, .undo').attr('disabled', true);
            }else {
                this.signature.jSignature('enable', true);
                this.signature.find('.reset, .undo').attr('disabled', false);
            }
        }
        
        if(changedProps.signatureVal != undefined){
            if(this.ignoreValChangeEvent) {
                this.ignoreValChangeEvent = false;
                return;
            }
            this.draw();
        }
    }

    draw() {
        this.ignoreValChangeEvent = false;
        this.signature.unbind('change');
        this.set();
        let emptySVS='<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="0" viewBox="0 0 0 0" ></svg>';
        let datapair = this.signatureItem.properties.Basic.Value.selectedValue;
        if (datapair && datapair[1] != "" && datapair[1] != emptySVS) {
            this.signature.find('canvas').remove();
            this.signature.append(datapair[1]);
            this.signature.find('svg').css({'width':'auto', 'margin': '18px'});
            this.signature.find('.reset').css({
                'position': 'absolute',
                'float':'right',
                'right': '89px',
                'top': '0px'
            }).attr('disabled', false).unbind('click').bind('click', () => {
                this.reset();
            });
        }
    }
    
    set() {
        this.signature.empty();
        this.signature.jSignature({
            UndoButton: !this.signatureDisabled,
            ResetButton: !this.signatureDisabled,
            width:'100%',
            lineWidth:2,
            height:'100px'
        });

        if(this.signatureDisabled) {
            this.signature.jSignature('disable', true);
        }

        this.signature.unbind('change').bind('change', () => {
            this.ignoreValChangeEvent = true;
            this.signatureItem.properties.Basic.Value.selectedValue = this.signatureVal = this.signature.jSignature('getData','svg');
            this.validateRequiredField();
            this.signatureChanged();
        });
    }

    reset() {
        this.ignoreValChangeEvent = true;
        this.signatureItem.properties.Basic.Value.selectedValue = this.signatureVal = '';
        this.set();
    }

    
    validateRequiredField() {
        let isModified = this.signature.jSignature("isModified");
        let data = this.signature.jSignature('getData','svg');
        let emptyCanvas = ["image/svg+xml", '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0"></svg>'];
        if (!isModified &&  (data == "" || JSON.stringify(data) == JSON.stringify(emptyCanvas))) {
            this.signatureItem.properties.Basic.Value.selectedValue = this.signatureVal = '';
        } 
    }
}  

export default angular.module('directives.asiteSignature', [])
.component('asiteSignature', {
    template: "<div ng-style=\"{'background-color': '#f5f5f5',width: '100%','overflow-x':'auto'}\" class=\"clearfix\"></div>",
    controller: SignatureComponent,
    controllerAs: 'signCtrl',
    bindings: {
       signatureItem: '<',
       signatureColor:'<',
       signatureDisabled:'<',
       signatureVal: '<',
       signatureChanged: '&'
    }
    
}).name;



// WEBPACK FOOTER //
// ./client/components/signature/signature.component.ts